// pipe to $dict
import { Dict } from 'ivux-dict-manager/src/index'

export default Dict